import { localize } from 'helpers/translator'
import { createSelector } from 'reselect'
import activePairSelector from './creation_tool_active_pair_selector'
import validPairsSelector from './creation_tool_valid_pairs_selector'

export default createSelector(
	[ activePairSelector, validPairsSelector ],
	(activePair, pairs) => {
		const pairStatus = {
			card1: {
				error: false,
				message: '',
			},
			card2: {
				error: false,
				message: '',
			},
		}
		if (activePair.card1.error) {
			pairStatus.card1.error = true
			pairStatus.card1.message = activePair.card1.error
		} else if (!activePair.card1.touched && ( activePair.card1.value === null || activePair.card1.value === '')) {
			pairStatus.card1.error = true
			pairStatus.card1.message = localize('matching_pairs_ct_addTextImage')
		}

		if (activePair.card2.error) {
			pairStatus.card2.error = true
			pairStatus.card2.message = activePair.card2.error
		} else if (!activePair.card2.touched && ( activePair.card2.value === null || activePair.card2.value === '')) {
			pairStatus.card2.error = true
			pairStatus.card2.message = localize('matching_pairs_ct_addTextImage')
		}
		let pairsLength = pairs.length+1
		if (activePair.id !== 0) {
			for (let x=0 ; x < pairs.length ; x++) {
				if (pairs[x].id === activePair.id ) {
					pairsLength = x+1
					break
				}
			}
		}

		const canSave = () => {

			let card1valid = false
			let card2valid = false

			if (activePair.card1.type === 'text'
			|| (activePair.card1.type === 'image'
			&& activePair.card1.value.icon.id !== 0
			&& activePair.card1.value.matrix[0] !== -1)) {
				card1valid = true
			}

			if (activePair.card2.type === 'text'
			|| (activePair.card2.type === 'image'
			&& activePair.card2.value.icon.id !== 0
			&& activePair.card2.value.matrix[0] !== -1)) {
				card2valid = true
			}

			return card1valid && card2valid
		}

		return {
			...activePair,
			title: `${localize('matching_pairs_ct_pair')} ${pairsLength}`,
			pairStatus,
			showAddAnotherPair: pairs.length < 11,
			canSave: canSave(),
		}
	}
)
